import invoiceAPI from '@/services/API/invoice'
import customerAPI from '@/services/API/customer'
import _ from 'lodash';


const fetchCustomerInvoices = function({commit, state}, params){
  // let params = {customerId:state.customerId, unpaid:true, paging:'no', statusCode:['SENT','PARTIALLY_PAID'], orderBy:"date", direction:'ASC' }
  // let params = {customerId:state.customerId, , paging:'no' }
  params.customerId = state.customerId;
  commit('SET_LOADING', true);
  invoiceAPI.fetchPublicInvoices(params)
    .then(invoices=>{
      commit('SET_INVOICES',invoices);
      commit('SET_LOADING', false);
    })
}

const fetchCustomerInfos = function({commit, state}, customerId){
  commit('SET_LOADING_STATS', true);
  customerAPI.getPublicCustomer(customerId)
    .then(customer=>{
      commit('SET_BALANCE', customer.balance.balanceAccount);
      commit('SET_CREDIT', customer.balance.credit);
      commit('SET_LOADING_STATS', false);
    })
}

const setCustomerId = function({commit}, customerId){
  commit('SET_CUSTOMER_ID', customerId);
}

const setSelectedInvoices = function({commit, state}, selectedInvoices){
  if (_.isEmpty(state.selectedInvoices)) {
    // Alors on persiste le companyID
    commit('SET_PORTAUS_COMPANY_ID', _.head(selectedInvoices).portausCompany.id);
  } 
 

  commit('SET_SELECTED_INVOICES', selectedInvoices);

  if (_.isEmpty(selectedInvoices)){
    commit('SET_PORTAUS_COMPANY_ID', null);
  }
}

const selectInvoice = function({commit, state, getters}, {id, selected}){
  console.log('selectInvoice : ', id, selected);
  let index = _.findIndex(state.invoices, i=>{return i.id==id});

  commit('SET_SELECT_ATTRIBUTE', {index, selected});
  if(selected){
    if (_.isEmpty(state.selectedInvoices)) {
      // Alors on persiste le companyID
      
      commit('SET_PORTAUS_COMPANY_ID', state.invoices[index].portausCompany.id);
    }
    commit('ADD_INVOICE_TO_SELECTION', state.invoices[index]);
  }else{
    let index = _.findIndex(state.selectedInvoices, i=>{return i.id==id});
   
    commit('REMOVE_INVOICE_TO_SELECTION', index);
    
  }

}

const clearSelectedInvoices = function({commit}){
  commit('CLEAR_SELECTED_INVOICES');
}

export default {
  fetchCustomerInvoices,
  setCustomerId,
  setSelectedInvoices,
  selectInvoice,
  clearSelectedInvoices,
  fetchCustomerInfos
};
